// Category data and icons for product filtering
import { 
  Smartphone, 
  Shirt, 
  Home, 
  Dumbbell, 
  Sparkles, 
  Package,
  Monitor,
  Watch,
  Headphones,
  Camera
} from 'lucide-react';

// Product categories with icons and colors
export const CATEGORIES = [
  { 
    id: 'Electronics', 
    name: 'Electronics', 
    icon: Smartphone, 
    color: 'bg-blue-500',
    lightColor: 'bg-blue-50',
    textColor: 'text-blue-600',
    description: 'Gadgets & Tech'
  },
  { 
    id: 'Fashion', 
    name: 'Fashion', 
    icon: Shirt, 
    color: 'bg-pink-500',
    lightColor: 'bg-pink-50',
    textColor: 'text-pink-600',
    description: 'Clothing & Accessories'
  },
  { 
    id: 'Home', 
    name: 'Home & Garden', 
    icon: Home, 
    color: 'bg-green-500',
    lightColor: 'bg-green-50',
    textColor: 'text-green-600',
    description: 'Decor & Living'
  },
  { 
    id: 'Sports', 
    name: 'Sports', 
    icon: Dumbbell, 
    color: 'bg-orange-500',
    lightColor: 'bg-orange-50',
    textColor: 'text-orange-600',
    description: 'Fitness & Outdoors'
  },
  { 
    id: 'Beauty', 
    name: 'Beauty & Health', 
    icon: Sparkles, 
    color: 'bg-purple-500',
    lightColor: 'bg-purple-50',
    textColor: 'text-purple-600',
    description: 'Skincare & Wellness'
  },
  { 
    id: 'General', 
    name: 'General', 
    icon: Package, 
    color: 'bg-gray-500',
    lightColor: 'bg-gray-50',
    textColor: 'text-gray-600',
    description: 'Everything Else'
  },
];

// Get category by ID
export const getCategoryById = (id) => {
  return CATEGORIES.find(cat => cat.id === id) || CATEGORIES[CATEGORIES.length - 1];
};

// Get category icon component
export const getCategoryIcon = (categoryId) => {
  const category = getCategoryById(categoryId);
  return category.icon;
};

export default CATEGORIES;
